<template>
  <div>
    <ScrollToTopButton bottomPixels="75px" />
    <div class="background-container">
      <div class="background-overlay">
        <h1 class="category-title felix007">
          <span :style="getCategoryNameDisplay.color">
            <span class="white-text">{{
              getCategoryNameDisplay.firstWord === "הסל"
                ? "כל "
                : $route.query.filter === "הסל שלי"
                ? "הסל שלי -  "
                : ""
            }}</span>
            {{ getCategoryNameDisplay.firstWord }}</span
          >
          {{ getCategoryNameDisplay.word }}
        </h1>
      </div>
    </div>
    <section class="main-contant">
      <BaseSearch v-if="!isDesktop"></BaseSearch>
      <CategoryActions />

      <div v-if="showSubCategoryTags" class="subcategory-tags">
        <button
          v-for="(subCatGroup, index) in subCategorizedProducts"
          :key="subCatGroup.subCategory || 'none'"
          type="button"
          class="subcategory-tag"
          @click="scrollToSubCategory(index)"
        >
          {{ subCatGroup.subCategory }}
        </button>
      </div>

      <div class="padding-botton-100" v-if="categorizedProductList.length > 0">
        <div
          v-for="categoryGroup in categorizedProductList"
          :key="categoryGroup.category"
        >
          <h5 class="category-label">{{ categoryGroup.category }}</h5>
          <div
            v-for="subCatGroup in categoryGroup.subCategories"
            :key="subCatGroup.subCategory || 'none'"
            :class="{ 'products-continer': isDesktop }"
          >
            <h6 v-if="categoryGroup.hasSubCategories" class="subcategory-label">{{ subCatGroup.subCategory }}</h6>
            <PrdouctItem
              v-for="(product, index) in subCatGroup.products"
              :key="product.part"
              :index="index"
              :product="product"
              :ord="getCart.ord"
              :quant="getProdcutInfoFromCartIfExist(product.part).quant"
              :ordi="getProdcutInfoFromCartIfExist(product.part).ordi"
            />
          </div>
        </div>
      </div>
      <div class="padding-botton-100" v-else-if="filteredProducts.length > 0">
        <div
          v-for="(subCatGroup, index) in subCategorizedProducts"
          :key="subCatGroup.subCategory || 'none'"
          :id="`subcategory-section-${index}`"
          :class="{ 'products-continer': isDesktop }"
        >
          <h5 v-if="subCategorizedProducts.some(g => g.subCategory !== 'אחרים')" class="subcategory-label">{{ subCatGroup.subCategory }}</h5>
          <PrdouctItem
            v-for="(product, index) in subCatGroup.products"
            :key="product.part"
            :index="index"
            :product="product"
            :ord="getCart.ord"
            :quant="getProdcutInfoFromCartIfExist(product.part).quant"
            :ordi="getProdcutInfoFromCartIfExist(product.part).ordi"
          />
        </div>
      </div>

      <NotFound v-else>
        {{ notFoundMessage }}
      </NotFound>
    </section>
  </div>
</template>

<script>
import PrdouctItem from "../helpers/ProductItem.vue";
import CategoryActions from "../helpers/CategoryActions.vue";
import BaseSearch from "../menus/BaseSearch.vue";
import { mapGetters } from "vuex";
import NotFound from "../helpers/NotFound.vue";
import ScrollToTopButton from "../helpers/ScrollToTopButton.vue";

export default {
  components: {
    PrdouctItem,
    CategoryActions,
    NotFound,
    BaseSearch,
    ScrollToTopButton,
  },
  data() {
    return {
      productListLength: 0,
    };
  },
  methods: {
    getProdcutInfoFromCartIfExist(part) {
      const cart = this.$store.getters["Orders/getCart"];
      const orderLine = cart.OrderLines.find(
        (orderLine) => orderLine.part === part
      );
      if (orderLine) {
        return {
          quant: orderLine.quant,
          ordi: orderLine.ordi,
        };
      } else {
        return {
          quant: 0,
          ordi: 0,
        };
      }
    },
    filterProduct(product) {
      let displayProduct = true;
      const categoryParam = this.$route.params.category;
      const filter = this.$route.query.filter;
      if (categoryParam) {
        if (categoryParam === "הסל שלי" || filter === "הסל שלי") {
          if (!(product.CustParts.length > 0 && product.CustParts[0].Star)) {
            displayProduct = false;
          }
        }
        if (categoryParam === "מומלצים") {
          if (!product.isRecommended) displayProduct = false;
        } else if (categoryParam !== "חיפוש" && categoryParam !== "הסל שלי") {
          const productCategory = product.Family.familyname;
          if (productCategory !== categoryParam) displayProduct = false;
        }
      }

      const searchQuery = this.$route.query.search;
      if (searchQuery) {
        const values = Object.values(product);
        const proudctHasValues = values.some((value) => {
          return String(value).includes(searchQuery);
          // return String(value).toLowerCase().includes(searchQuery.toLowerCase());
        });
        if (!proudctHasValues) displayProduct = false;
      }

      return displayProduct; // All tets passed successfully and the product should be displayed
    },
    scrollToSubCategory(index) {
      const el = document.getElementById(`subcategory-section-${index}`);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    sortSubCategoryGroups(groups) {
      return groups.slice().sort((a, b) => {
        const familycodeA = a.products[0]?.Family?.familycode;
        const familycodeB = b.products[0]?.Family?.familycode;
        return (
          this.getSubCategorySortOrder(familycodeA, a.subCategory) -
          this.getSubCategorySortOrder(familycodeB, b.subCategory)
        );
      });
    },
  },
  computed: {
    productsByCategory() {
      return this.filteredProducts.reduce((acc, product) => {
        // If the category doesn't exist in the accumulator, create it
        if (!acc[product.Family.familyname]) {
          acc[product.Family.familyname] = [];
        }
        // Add the product to its category
        acc[product.Family.familyname].push(product);
        return acc;
      }, {});
    },
    subCategorizedProducts() {
      const groups = this.filteredProducts.reduce((acc, product) => {
        const subCat = product.partSubCategory || 'אחרים';
        const existing = acc.find((g) => g.subCategory === subCat);
        if (existing) {
          existing.products.push(product);
        } else {
          acc.push({ subCategory: subCat, products: [product] });
        }
        return acc;
      }, []);
      return this.sortSubCategoryGroups(groups);
    },
    categorizedProductList() {
      if (
        this.$route.params.category === "הסל שלי" ||
        this.$route.params.category === "חיפוש"
      ) {
        return Object.entries(this.productsByCategory)
          .map(([category, products]) => {
            const sortedProducts = products.sort(
              (a, b) => a.Family.sortOrderNumber - b.Family.sortOrderNumber
            );
            const rawSubCategories = sortedProducts.reduce((acc, product) => {
              const subCat = product.partSubCategory || 'אחרים';
              const existing = acc.find((g) => g.subCategory === subCat);
              if (existing) {
                existing.products.push(product);
              } else {
                acc.push({ subCategory: subCat, products: [product] });
              }
              return acc;
            }, []);
            const subCategories = this.sortSubCategoryGroups(rawSubCategories);
            const hasSubCategories = subCategories.some((g) => g.subCategory !== 'אחרים');
            return { category, subCategories, hasSubCategories };
          })
          .sort((a, b) => {
            const firstProductA = a.subCategories[0].products[0];
            const firstProductB = b.subCategories[0].products[0];
            return (
              firstProductA.Family.sortOrderNumber -
              firstProductB.Family.sortOrderNumber
            );
          });
      } else {
        return [];
      }
    },
    showSubCategoryTags() {
      return (
        this.categorizedProductList.length === 0 &&
        this.subCategorizedProducts.some((g) => g.subCategory !== "אחרים")
      );
    },
    notFoundMessage() {
      const category = this.$route.params.category;
      const searchQuery = this.$route.query.search;

      if (category === "הסל שלי" && !searchQuery) {
        return "אין לך מוצרים. ניתן להוסיף מוצרים על ידי לחיצה על הכוכב בכרטיסיית המוצר.";
      } else if (category === "חיפוש") {
        return "לא הצלחנו למצוא את המוצר שחיפשת";
      } else {
        return `לא הצלחנו למצוא המוצר שחיפשת בקטגוריית ${category}`;
      }
    },
    filteredProducts() {
      return this.getProducts.filter((product) => this.filterProduct(product));
    },
    getCategoryNameDisplay() {
      let styleColor = "color: white";
      const words = this.$route.params.category.split(" ");
      if (words.length === 1) styleColor = "color: inherit";
      const firstWordWhiteColor = words.shift();
      return {
        firstWord: firstWordWhiteColor,
        color: styleColor,
        word: words.join(" "),
      };
    },
    ...mapGetters({
      getProducts: "Parts/getParts",
      getSubCategorySortOrder: "Parts/getSubCategorySortOrder",
      getCustname: "AuthModule/getCustname",
      getCart: "Orders/getCart",
      isDesktop: "isDesktop",
      isLaptop: "isLaptop",
      isTablet: "isTablet",
      isMobile: "isMobile",
    }),
  },
};
</script>

<style scoped lang="scss">
.category-label {
  color: $primaryColor;
  font-weight: 800;
  padding: 5px 10px;
  font-size: 26px;
  margin-top: 60px;
  background: linear-gradient(
    60deg,
    rgba(0, 0, 0, 0) 30%,
    rgba(255, 230, 173, 1) 97%
  );
  border-radius: 10px;
}

.subcategory-tags {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 10px;
  margin-top: 15px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.subcategory-tag {
  flex: 0 0 auto;
  white-space: nowrap;
  background-color: transparent;
  color: $primaryTextColor;
  border: 2px solid #601b0f;
  border-radius: 20px;
  padding: 8px 18px;
  font-size: $mediumTextSize;
  font-weight: 600;
  cursor: pointer;
}

.subcategory-label {
  color: $primaryTextColor;
  font-weight: 500;
  padding: 4px 10px;
  font-size: 27px;
  font-weight: 800;
  margin-top: 15px;
  margin-bottom: 5px;
  background: linear-gradient(
    60deg,
    rgba(0, 0, 0, 0) 30%,
    #6d1106 97%
  );
  border-radius: 8px;
}

.background-container {
  background-image: url("/images/background-categories.png");
  background-size: 100%;
  background-position-y: -250px;
  background-repeat: no-repeat;
  width: 100%;
  height: 240px;

  .background-overlay {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    background: linear-gradient(179deg, #161616 10%, rgba(0, 0, 0, 0.412) 80%);
    width: 100%;
    height: 100%;
  }
}

@media (max-width: 1200px) {
  .background-container {
    height: 170px;
    background-position-y: 0px;
  }
}

@media (max-height: 667px) {
  .background-container {
    height: 140px;
    background-position-y: 0px;
  }
}

@media (min-width: 1400px) {
  .products-continer {
    grid-template-columns: repeat(3, 1fr) !important;
  }
}
@media (min-width: 1024px) {
  .products-continer {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-top: 20px !important;
  }
  .img-overlay {
    background: unset !important;
  }
}

.products-continer {
  // height: calc(85vh - 180px);
  // max-height: 450px;
  margin-top: 30px;
  // overflow: scroll;
  // padding-left: 500px;
  // overflow-x: hidden;
  // padding-bottom: 100px;
}

@media (max-width: 1100px) {
  .products-continer {
    padding-left: 0px;
  }

  .scroll {
    overflow-y: scroll;
  }
}

.main-contant {
  width: 100%;
  position: relative;
  z-index: 5;
  padding: $mainContentPadding;
  margin-top: -50px;
  // margin-bottom: 75px;
}
.category-title {
  color: $primaryTextColor;
  font-weight: normal;
  font-size: 2.4rem !important;
  margin-top: 0px;
  width: 100%;
  padding: 0px $mainContentPadding;
  margin-bottom: 40px;

  span {
    color: white;
  }
}

.no-prdocuts-found-container {
  flex-direction: column;
  gap: 10px;
  height: 400px;
  h1 {
    color: $primaryTextColor;
    font-size: $largTextSize;
    text-align: center;
    margin: 0;
  }
}
</style>
